import React from 'react'
import { Message, Button } from 'semantic-ui-react'
import '../App.css';

export default class ConfirmToastr extends React.Component{
  componentDidMount = () => {
    var modal = document.getElementById("myModal");
    modal.style.display = "block";
  }

  dismiss = () => {
    this.props.dismiss();
  }

  yes = () => {
    this.props.messageYes();
    this.dismiss();
  }

  render(){
    let messageHeader = this.props.messageHeader
    let messageBody = this.props.messageBody
    let messageType = this.props.messageType
    const { yes, no } = this.props.options
    return (
      <div id="myModal" className="toastr-background">
        <Message floating className={`toastr toastr-${messageType}`}>
          {
            !this.props.noDimiss &&
            <i className="close icon" onClick={ this.dismiss.bind(this) }></i>
          }
          <Message.Header>
            {messageHeader}
          </Message.Header>
          <p>
            {messageBody}
          </p>
          <span>
            <Button fluid size='small' color='teal' onClick={this.yes.bind(this)} className="yes-confirm-button">{yes}</Button>
            <Button fluid size='small' color='teal-outline' onClick={this.dismiss.bind(this)} className="no-confirm-button">{no}</Button>
          </span>
        </Message>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm_toastr.js